module.exports = __webpack_public_path__ + "img/file-orange.61c62190.svg";